<template>
    <div>
        <FemaleHair :baseUrl="baseUrl" v-if="user.gender==='Female'"/>
        <MaleHairLoss :baseUrl="baseUrl" v-else/>
    </div>
</template>
<script>

import FemaleHair from "./FemaleHairLossForm.vue"
import MaleHairLoss from "./MaleHairLoss.vue"
export default {
    name: 'HairLossQuestionnaire',
    props: ['baseUrl'],
    components: {
        FemaleHair,
        MaleHairLoss
    },
    data() {
        return {
            user:''
        }
    },
    created() {
        this.user = this.$store.getters.user;
    }
}
</script>